/**
 * Created by 丸子 on 2018/6/30.
 */
import Vue from 'vue'
import App from './app.vue'

import  '@/assets/js/Slot'
import  '@/assets/js/Vote'
import  '@/assets/js/CrossChainMoney'
import  '@/assets/js/ThreeKingdoms'
import  '@/assets/js/TKConfig'
import  '@/assets/js/TKHero'

import '@/util/page'
import store from '@/store'
import router from './router'
import {i18n} from "@/util/page";

// if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
//   // alert('手机')
//   setTimeout(()=>{
//     window.threeKingdoms.init().finally(()=>{
//       new Vue({
//         el: '#app',
//         store,
//         router,
//         i18n,
//         render: h => h(App)
//       })
//     })
//   },200)
// }else{
//   // alert('电脑')
//
// }

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
})



